// extracted by mini-css-extract-plugin
module.exports = {"BaseButton":"BaseButton_BaseButton__xb8p2","Hovered":"BaseButton_Hovered__BbGEM"};